import z from "zod";

import { CALL_ANSWER_STATUS_FILTERS } from "@/types/call-answer-status-filter.types";
import { CALL_METRIC_FILTERS } from "@/types/call-metric-filter.types";

export const CallsSearchParamsSchema = z.object({
    agent: z.string().optional(),
    page: z.coerce.number().int().min(1).optional(),
    start: z.string().optional(),
    end: z.string().optional(),
    metric: z.enum(CALL_METRIC_FILTERS).optional(),
    answerStatus: z.enum(CALL_ANSWER_STATUS_FILTERS).optional(),
    durationSecondsMin: z.coerce.number().int().min(1).optional(),
    durationSecondsMax: z.coerce.number().int().min(1).optional(),
    overallScoreMin: z.coerce.number().min(0).max(100).optional(),
    overallScoreMax: z.coerce.number().min(0).max(100).optional(),
});

export type CallsSearchParams = z.infer<typeof CallsSearchParamsSchema>;
